
import { Component, Vue, Prop } from 'vue-property-decorator';

import { Row } from '@warrenbrasil/nebraska-web';
import { StatementRow } from './components/StatementRow';
import { ReceiptModal } from '@/modules/transaction/components/ReceiptModal';

import { HomeStatement } from '@/modules/home/services/bff';
import * as trackEvents from '../../track-events';

@Component({
  components: {
    Row,
    ReceiptModal,
    StatementRow
  }
})
export default class StatementsList extends Vue {
  @Prop({ type: Array })
  readonly statements!: HomeStatement[];

  selectedStatement: HomeStatement | null = null;
  isStatementModalOpen = false;
  filters = {
    page: 1
  };

  handleStatementClick(statement: HomeStatement) {
    trackEvents.trackTransactionDetailsEvent(statement.name);
    this.selectedStatement = statement;
    this.isStatementModalOpen = true;
  }

  handleCloseModal() {
    this.isStatementModalOpen = false;
  }

  get computedStatementsPageHref() {
    return this.$router.resolve({ name: 'transactions' }).href;
  }

  get selectedStatementId() {
    return this.selectedStatement?.id;
  }

  handleSeeAllStatements() {
    trackEvents.trackViewMoreTransactionsEvent();
  }
}
